export const ELIGIBILITY_1_CONSTANTS = {
  ELIGIBILITY_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Eligibility Title",
      value: "Eligibility Criteria",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Eligibility Title",
      required: false,
      defaultValue: "Eligibility Criteria",
    },
    {
      fieldName: "title_text_color",
      label: "Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "description",
      label: "Description",
      value: "Check your eligibility for our programs",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Description",
      required: false,
      defaultValue: "Check your eligibility for our programs",
    },
    {
      fieldName: "description_text_color",
      label: "Description Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter description text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "button_text",
      label: "Button Text",
      value: "Read more",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Button Text",
      required: false,
      defaultValue: "Read more",
    },
    {
      fieldName: "button_text_color",
      label: "Button Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter button text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "button_color",
      label: "Button Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter button background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "button_icon",
      label: "Button Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Button Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "button_icon_alt",
      label: "Button Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for button icon",
      required: false,
      defaultValue: "Read more",
    },
    {
      fieldName: "read_more_text",
      label: "Read More Text",
      value: "Read More",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Read More Text",
      required: false,
      defaultValue: "Read More",
    },
    {
      fieldName: "read_more_color",
      label: "Read More Text Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter read more text color (e.g., #BE2330)",
      required: false,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "status",
      label: "Eligibility Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Eligibility",
      defaultValue: false,
    },
  ],
};

